import { useMemo } from "react";

export function useParams() {
  const routeParams = useMemo(() => window.location.pathname.split("/"), []);

  return { routeParams };
}
